// https://auction-webapp-production.up.railway.app/
// http://localhost:8085/

const BASE_URL = "https://auction-webapp-production.up.railway.app/api/v1";
export const BASE_WS = "https://auction-webapp-production.up.railway.app";

export default BASE_URL;
